export default __webpack_public_path__ + "static/media/2020-10-24-075044764 - 293_AARUSHI SHANKER.ee857d94.jpg";